var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"ds-icon",class:[_vm.size && ("ds-icon-size-" + _vm.size)],attrs:{"aria-label":_vm.ariaLabel}},[(_vm.svgComponent)?_c(_vm.svgComponent,{tag:"component",staticClass:"ds-icon-svg"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }